<template>

    <label
            class="my-check-tag"
            style="--color-active: var(--color-secondary)"
            :class="{ active: isChecked }"
            >
            
            <div class="check-box">
              <svg xmlns="http://www.w3.org/2000/svg" width="9" height="8">
                <path
                  fill-rule="nonzero"
                  d="M7.68198052 1.31801905L3.08578644 5.91421312 1.31801948 4.14644617c-.19526188-.19526188-.51184631-.19526046-.70710678 0-.19526046.19526047-.19526188.5118449 0 .70710678L2.73223305 6.9748733c.19526258.19526258.51184631.19526046.70710678 0L8.3890873 2.02512583c.19526046-.19526047.19526258-.5118442 0-.70710678-.19526188-.19526188-.51184632-.19526047-.70710678 0z" />
              </svg>
            </div>
            <div class="check-label">
              {{ label }}
            </div>
            <input type="checkbox" />
          </label>
          
</template>

<script>

export default {

    data(){
        return {
            isChecked: true
        }
    },

    props: {
      label:{
        type:String,
        required:true
      },
      id:{
        type: String,
        required: false
      }
    
  }
}
</script>

<style lang="scss">
@import '@/scss/abstracts/_variables.scss';
@import '@/scss/abstracts/_mixins.scss';


.my-check-tag-wrap {
  width: 100%;
  margin-bottom: 0;
}

.my-check-tag {
  cursor: pointer;
  @include transform($transform-base-tempo);
  background-color: #f7f7f7;
  float: left;
  @include br(100px);
  padding: 8px 10px;
  margin-right: 10px;
  margin-bottom: 10px;
  padding-right:15px;

  .check-box {
    width: 15px;
    height: 15px;
    background-color: #ffffff;
    float: left;
    margin-right: 5px;
    @include br(50%);
    @include valign(center);

    svg {
      display: none;
    }
  }

  .check-label {
    float: left;
    line-height: 15px;
    display: block;
    color: var(--main-bg-color);
  }

  &:hover {
    background-color: #f1f1f1;
  }

  &.active {
    background-color: var(--color-active, var(--color-primary));

    .check-box {
      svg {
        stroke: var(--color-active, var(--color-primary));
        fill: var(--color-active, var(--color-primary));
        display: block;
      }
    }

    .check-label {
      color: #ffffff;
    }
  }
}

</style>